/**
 * UserAvatar — profile photo with initials fallback, shared by the desktop
 * dropdown trigger, the dropdown card, and the mobile menu user row.
 */
import { cn } from '../../../lib/utils';
import SkeletonImg from '../../ui/SkeletonImg';

interface UserAvatarProps {
  photoURL: string | null;
  displayName: string;
  initials: string;
  isSukhasan: boolean;
  /** e.g. 'w-7 h-7' | 'w-8 h-8' | 'w-12 h-12' */
  sizeClass: string;
  /** Initials font size, e.g. 'text-[10px]' | 'text-xs' | 'text-sm' */
  textClass: string;
}

export default function UserAvatar({
  photoURL,
  displayName,
  initials,
  isSukhasan,
  sizeClass,
  textClass,
}: UserAvatarProps) {
  if (photoURL) {
    return (
      <SkeletonImg
        src={photoURL}
        alt={displayName}
        referrerPolicy="no-referrer"
        className={cn('rounded-full flex-shrink-0', sizeClass)}
      />
    );
  }
  return (
    <div
      className={cn(
        'rounded-full flex items-center justify-center font-bold flex-shrink-0',
        sizeClass,
        textClass,
        isSukhasan ? 'bg-sukhasan-800 text-kesri-400' : 'bg-kesri-100 text-kesri-700',
      )}
    >
      {initials}
    </div>
  );
}
